const DEFAULT_IMAGE_SERVICE_BASE_URL = "https://sales.image-service.eu-north-1-prod.vmnd.tv/admin";

const resolveImageServiceBaseUrl = (): string => {
    const candidates = [
        process.env.REACT_APP_IMAGE_SERVICE_BASE_URL,
        process.env.REACT_APP_API_IMAGE,
        DEFAULT_IMAGE_SERVICE_BASE_URL,
    ];
    const resolved =
        candidates.find(
            (candidate): candidate is string =>
                typeof candidate === "string" && candidate.trim() !== "",
        ) ?? DEFAULT_IMAGE_SERVICE_BASE_URL;
    return resolved.replace(/\/$/, "");
};

export const VIMOND_IMAGE_SERVICE_BASE_URL = resolveImageServiceBaseUrl();

export type SmartListAdapterOption = {
    id: number;
    name: string;
};

export const DEFAULT_SMART_LIST_ADAPTER_ID = 26 as const;

export const SMART_LIST_ADAPTER_OPTIONS: ReadonlyArray<SmartListAdapterOption> = [
    {
        id: DEFAULT_SMART_LIST_ADAPTER_ID,
        name: "Themes",
    },
];

export type SmartListSortOption = {
    value: string;
    label: string;
};

export const DEFAULT_SMART_LIST_SORT_OPTION = "-publishing.start";

export const SMART_LIST_SORT_OPTIONS: ReadonlyArray<SmartListSortOption> = [
    {
        value: DEFAULT_SMART_LIST_SORT_OPTION,
        label: "Published (Newest First)",
    },
    {
        value: "createTime",
        label: "Created (Newest First)",
    },
];

export type SmartListTemplateDefinition = {
    templateId: string;
    adapterId: number;
    label: string;
    requiresGenre: boolean;
    requiresLabels: boolean;
};

export const SMART_LIST_TEMPLATE_DEFINITIONS: ReadonlyArray<SmartListTemplateDefinition> = [
    {
        templateId: "107",
        adapterId: DEFAULT_SMART_LIST_ADAPTER_ID,
        label: "By Genre",
        requiresGenre: true,
        requiresLabels: false,
    },
    {
        templateId: "109",
        adapterId: DEFAULT_SMART_LIST_ADAPTER_ID,
        label: "By Tags",
        requiresGenre: false,
        requiresLabels: true,
    },
    {
        templateId: "112",
        adapterId: DEFAULT_SMART_LIST_ADAPTER_ID,
        label: "Marketing & Promos",
        requiresGenre: false,
        requiresLabels: true,
    },
    {
        templateId: "137",
        adapterId: DEFAULT_SMART_LIST_ADAPTER_ID,
        label: "Sports",
        requiresGenre: false,
        requiresLabels: true,
    },
];
